import React from 'react';
import { Helmet } from 'react-helmet-async';
import structuredData from '../structured-data.json';

const SEO = ({ title, description, path, image, noindex }) => {
  const siteUrl = 'https://figtree-corfecastle.co.uk';
  const seo = {
    title: title || 'Fig Tree Cottage, Corfe Castle | Dog-friendly holiday cottage in Dorset',
    description: description || 'Dog-friendly 3-bedroom holiday cottage in Corfe Castle, Isle of Purbeck, Dorset. Sleeps 5, large garden, steam-train views, wood burner. 5.0 on Airbnb. Book direct for our best price.',
    image: `${siteUrl}${image || '/og-image.jpg'}`,
    url: `${siteUrl}${path || '/'}`,
  };

  return (
    <Helmet>
      <title>{seo.title}</title>
      <meta name="description" content={seo.description} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={seo.url} />
      <meta property="og:title" content={seo.title} />
      <meta property="og:description" content={seo.description} />
      <meta property="og:image" content={seo.image} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={seo.url} />
      <meta name="twitter:title" content={seo.title} />
      <meta name="twitter:description" content={seo.description} />
      <meta name="twitter:image" content={seo.image} />

      {/* Structured data */}
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
    </Helmet>
  );
};

export default SEO;
